module.exports = __webpack_public_path__ + "img/smarttruck.fa511655.png";